import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Star, Quote, MapPin, ArrowRight } from "lucide-react";

export default function RecentReviews() {
  const [reviews, setReviews] = useState(null);

  useEffect(() => {
    let mounted = true;
    // Pull from the public testimonials collection (admin-managed real reviews)
    api.get("/testimonials?limit=6&offset=0")
      .then((r) => { if (mounted) setReviews(r.data?.items || []); })
      .catch(() => { if (mounted) setReviews([]); });
    return () => { mounted = false; };
  }, []);

  if (!reviews || reviews.length === 0) return null;

  return (
    <section data-testid="recent-reviews" className="section-pad bg-[#0A0F0B]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
          <div>
            <div className="font-display uppercase tracking-[0.3em] text-xs text-[#8DE038] mb-3">/ Real reviews</div>
            <h2 className="font-display uppercase tracking-tighter text-4xl md:text-6xl text-[#F0F4F1] heading-accent">What Leeds<br/>is saying.</h2>
          </div>
          <Link to="/reviews" className="btn-secondary text-xs" data-testid="see-all-reviews">See all reviews <ArrowRight size={14}/></Link>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.slice(0, 6).map((r, i) => (
            <div key={r.id || i} data-testid={`review-card-${i}`} className="border border-[#1F3325] bg-[#0F1712] p-6 hover:border-[#8DE038] transition-colors">
              <Quote size={22} className="text-[#8DE038]/40"/>
              <div className="flex items-center gap-1 mt-3">
                {Array.from({ length: 5 }).map((_, idx) => (
                  <Star key={idx} size={14} fill={idx < (r.rating || 5) ? "#8DE038" : "transparent"} className={idx < (r.rating || 5) ? "text-[#8DE038]" : "text-[#1F3325]"}/>
                ))}
              </div>
              <p className="mt-4 text-[#C8D4CB] text-sm leading-relaxed">"{r.comment || 'Top service from start to finish.'}"</p>
              <div className="mt-5 pt-4 border-t border-[#1F3325]">
                <div className="font-display uppercase tracking-widest text-sm text-[#F0F4F1]">{r.customer_name || "Customer"}</div>
                <div className="text-xs text-[#9CAEA3] mt-1 flex items-center gap-1 flex-wrap">
                  {r.area && (<><MapPin size={10} className="text-[#8DE038]"/>{r.area}</>)}
                  {r.area && r.service && <span className="text-[#1F3325]">·</span>}
                  {r.service && <span>{r.service}</span>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
